<template>
  <div class="animated fadeIn">
    <el-dialog title="Confirm Email Delete" :visible.sync="emailDeleteForm" width="30%">
      <span>Remove email [{{removeEmail}}]?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="emailDeleteForm = false">Cancel</el-button>
        <el-button type="primary" @click="confirmDeleteEmail(removeEmail)">Delete</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Add New Email Address" :visible.sync="emailAddForm" width="30%">
      <span>
        <el-form
          :model="newEmailForm"
          :rules="newEmailRules"
          ref="settingsForm"
          label-width="120px"
        >
          <el-form-item label="Email Address:">
            <el-input v-model="newEmailForm.email"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="emailAddForm = false">Cancel</el-button>
        <el-button type="primary" @click="confirmAddEmail()">Add Email</el-button>
      </span>
    </el-dialog>
    <b-row>
      <b-col sm="8" lg="8" offset="2">
        <b-card header="Settings">
          <el-collapse v-model="activeAccordion" accordion>
            <el-collapse-item title="Report Email Message Settings" :name="1">
              <el-form
                :model="settingsForm"
                :rules="rules"
                ref="settingsForm"
                label-width="160px"
                class="demo-settingsForm"
              >
                <el-divider content-position="center">️✉️</el-divider>

                <el-divider content-position="left">Administration Email Addresses:</el-divider>

                <p
                  style="margin-left:160px;"
                >This setting allows you to select who will receive reports in your organization.</p>
                <el-form-item label="Admin Emails:">
                  <div style="margin-top:3px;">
                    <span v-for="email in settingsForm.emails" :key="email.$index">
                      <el-button
                        size="mini"
                        round
                        style="margin-right: 5px;"
                        @click="showEmailDelete(email)"
                      >{{email}}</el-button>
                    </span>
                    <el-button
                      size="mini primary"
                      icon="el-icon-edit"
                      round
                      style="margin-right: 5px;"
                      @click="showEmailAdd()"
                    >Add Email</el-button>
                  </div>
                </el-form-item>
                <el-divider content-position="left">Message sent with report:</el-divider>

                <p
                  style="margin-left:160px;"
                >This email will be sent to the client administrator or test taker once the report has been generated. Below, you can customize the subject line and message to be sent. Use the “Available Tags” for variable text such as, test taker name and type of report.</p>
                <p style="margin-left:160px;">
                  Available Tags:
                  <i>[TestCode] [UserEmail] [ReportType] [FirstName] [LastName]</i>
                </p>

                <el-form-item label="Email Subject:" prop="emailSubject">
                  <el-input v-model="settingsForm.emailSubject"></el-input>
                </el-form-item>
                <el-form-item label="Email Message:">
                  <el-input
                    v-model="settingsForm.emailMessage"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10}"
                  ></el-input>
                </el-form-item>

                <el-divider content-position="left">Email Test Takers Their Report:</el-divider>
                <p
                  style="padding-left: 160px;"
                >This enables the system to email reports to test taker. Green enables this feature.</p>
                <el-form-item label="Email Test-Takers:">
                  <el-switch
                    v-model="settingsForm.receiveReport"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    style="margin-top:10px;"
                  ></el-switch>
                  <!-- <el-radio
                    v-model="settingsForm.receiveReport"
                    :label="true"
                    size="medium"
                  >Test takers receive their reports via email</el-radio>
                  <br />
                  <el-radio
                    v-model="settingsForm.receiveReport"
                    :label="false"
                    size="medium"
                  >Test takers don't receive an email</el-radio>-->
                </el-form-item>
                <el-divider content-position="left">Allow Test Takers a Download Link:</el-divider>
                <p
                  style="padding-left: 160px;"
                >If the above "Email Test-Takers" is enabled, this feature will enable the test take to download their report once the assessment has been completed.</p>
                <el-form-item label="Download Link:">
                  <el-switch
                    v-model="settingsForm.downloadReport"
                    :disabled="!settingsForm.receiveReport"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    style="margin-top:10px;"
                  ></el-switch>
                  <!-- <el-radio
                    v-model="settingsForm.downloadReport"
                    :label="true"
                    :disabled="!settingsForm.receiveReport"
                    size="medium"
                  >Test takers can download their report when finished</el-radio>
                  <br />
                  <el-radio
                    v-model="settingsForm.downloadReport"
                    :label="false"
                    :disabled="!settingsForm.receiveReport"
                    size="medium"
                  >Test takers are not presented a download link</el-radio>-->
                  <p></p>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveSettings()">Save</el-button>
                </el-form-item>
              </el-form>
            </el-collapse-item>
            <el-collapse-item title="Demographics" name="2">
              <el-divider content-position="center">️👥</el-divider>
              <p>Below, are the demographic questions presented to the test take. Test takes will be required to complete these selected variables upon entering the system. These variables will also be included when you request data to be downloaded.</p>
              <p>Note: These demographic questions will be presented in the language that the test taker selected.</p>
              <p v-if="anonymousNotice < 3" style="color:red">
                <b>Caution:</b> It is highly recommended that you collect First Name, Last Name &amp; Email Addresses.
              </p>
              <el-form label-width="160px">
                <span v-for="d in demo.source" :key="d.$index">
                  <el-form-item
                    label
                    v-if="demo.include.indexOf(d.id) > -1"
                    style="margin-bottom: 5px;"
                  >
                    <el-checkbox
                      v-if="demo.include.indexOf(d.id) > -1"
                      v-model="demo.checked[d.id]"
                    >{{d.name_eng}}</el-checkbox>
                  </el-form-item>
                </span>
                <el-form-item>
                  <el-button type="primary" @click="saveDemographics()">Save</el-button>
                </el-form-item>
              </el-form>
            </el-collapse-item>
            <el-collapse-item title="Invite Email Message Settings" name="3">
              <el-divider content-position="center">️✉️</el-divider>
              <p>This email will be sent to the test taker inviting them to take the assessment. Below, you can customize the subject line and message to be sent in this initial email. Use the “Available Tags” for variable text such as test taker name and test code.</p>
              <p>
                Available Tags:
                <i>[CODE] [Link] [Company] [UserEmail] [ReportType] [FirstName] [LastName]</i>
              </p>
              <el-form label-width="160px">
                <el-form-item label="Email Subject:">
                  <el-input v-model="settingsForm.inviteSubjectLine"></el-input>
                </el-form-item>
                <el-form-item label="Email Message:">
                  <el-input
                    v-model="settingsForm.inviteMessage"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10}"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveSettings()">Save</el-button>
                </el-form-item>
              </el-form>
            </el-collapse-item>

            <el-collapse-item v-if="is360Enabled" title="360 Invite Email Message Settings" name="9">
              <el-divider content-position="center">️✉️</el-divider>
              <p>This email will be sent to all of the test taker inviting them to take the 360 assessment. Below, you can customize the subject line and message to be sent in this initial email. Use the “Available Tags” for variable text such as test taker name and test code.</p>
              <p>
                Available Tags:
                <i>[Company] [UserEmail] [ReportType] [FirstName] [LastName] [Table]</i>
              </p>
              <el-form label-width="160px">
                <el-form-item label="Email Subject:">
                  <el-input v-model="settingsForm.invite360SubjectLine"></el-input>
                </el-form-item>
                <el-form-item label="Email Message:">
                  <el-input
                    v-model="settingsForm.invite360Message"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10}"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveSettings()">Save</el-button>
                </el-form-item>
              </el-form>
            </el-collapse-item>

            <el-collapse-item v-if="isEmulated" title="Administrative Settings" name="4">
              <el-divider content-position="center">️➕</el-divider>
              <el-form label-width="160px">
                <p>Allow your client to add new packages and add new codes to existing packages.</p>
                <el-form-item label="Add Packages:">
                  <el-switch
                    v-model="settingsForm.enablePackages"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    style="margin-top:10px;"
                  ></el-switch>
                </el-form-item>
                <p>&nbsp;</p>
                <p>Allow your client to import test taker lists and send codes.</p>
                <el-form-item label="Email Distribution:">
                  <el-switch
                    v-model="settingsForm.enableEmailWizard"
                    :disabled="!settingsForm.enablePackages"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    style="margin-top:10px;"
                  ></el-switch>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveSettings()">Save</el-button>
                </el-form-item>
              </el-form>
            </el-collapse-item>
            <el-collapse-item
              v-if="isEmulated && settingsForm.enablePackages"
              title="Enabled Instruments"
              name="6"
            >
              <p>Below are the instruments the admin will have access to:</p>
              <el-form label-width="160px">
                <span v-for="d in instrumentNames" :key="d.$index">
                  <el-form-item label style="margin-bottom: 5px;">
                    <el-checkbox v-model="distributorInstrument[d.value]">{{d.label}}</el-checkbox>
                  </el-form-item>
                </span>
                <el-form-item>
                  <el-button type="primary" @click="saveDemographics()">Save</el-button>
                </el-form-item>
              </el-form>
            </el-collapse-item>
            <el-collapse-item v-if="settingsForm.photoUploadForm" title="Custom Logo" name="7">
              <el-divider content-position="center">️🖼</el-divider>
              <el-form ref="authentication" label-width="160px" class="demo-settingsForm">
                <p>This logo will be added to the client test taking platform and the report should the report support such things as custom logos.</p>
                <el-upload
                  class="upload-demo text-center"
                  drag
                  name="customPhoto"
                  :action="basePath + 'settings/image'"
                  :headers="getFileUploadHeaders"
                  :file-list="fileList"
                  :on-success="onSuccess"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Drop file here or
                    <em>click to upload</em>
                  </div>
                  <div
                    class="el-upload__tip"
                    slot="tip"
                  >Only [jpg/png] files with a size less than 1,500kb. The preferred dimensions are 540 pixels in width, and 140 pixels in height.</div>
                </el-upload>
              </el-form>
            </el-collapse-item>
            <el-collapse-item title="Password Settings" name="5">
              <el-divider content-position="center">️🔑</el-divider>
              <el-form ref="authentication" label-width="160px" class="demo-settingsForm">
                <!-- <el-form-item label="Username:">{{getUsername}}</el-form-item> -->
                <el-form-item label="Old Password:">
                  <el-input autocomplete="false" type="password" v-model="auth.oldPassword"></el-input>
                </el-form-item>

                <el-form-item label="Password:">
                  <el-input autocomplete="false" type="password" v-model="auth.password1"></el-input>
                </el-form-item>

                <el-form-item label="Repeat Password:" prop="passwordRepeat">
                  <el-input autocomplete="false" type="password" v-model="auth.password2"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="updateAuthentication()">Update</el-button>
                </el-form-item>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { basePath } from '../../shared/basePath';
import axios from '../../shared/axios';

export default {
  name: 'dashboard',
  components: {},
  computed: {
    ...mapGetters('auth', [
      'getCompanyName',
      'getDistributorName',
      'isDistributor',
      'isEmulated',
      'getUsername',
      'getToken',
      'is360Enabled'
    ]),

    getFileUploadHeaders() {
      const split = ' ';
      const headerKey = 'Bearer';
      return {
        authorization: headerKey + split + String(this.getToken)
      };
    }
  },
  data() {
    return {
      //
      basePath: basePath(),
      fileList: [],
      // Demo Anonymous mode
      anonymousNotice: 0,
      // Accordion
      activeAccordion: 0,

      // distributor enabled
      instrumentNames: undefined,
      distributorInstrument: [],

      // Settings
      settings: {},
      // Enable Visibility of Forms
      emailAddForm: false,
      emailDeleteForm: false,
      photoUploadForm: false,

      removeEmail: '',
      newEmailForm: {
        email: ''
      },
      messagePreview: {
        emailSubject: undefined,
        emailMessage: undefined
      },
      auth: {
        oldPassword: '',
        password1: '',
        password2: ''
      },
      settingsForm: {
        emailSubject: '',
        emailMessage: '',
        newEmailAddress: '',
        receiveReport: undefined,
        downloadReport: undefined,
        enablePackages: undefined,
        enableEmailWizard: undefined,
        emails: [],
        inviteMessage: '',
        inviteSubjectLine: '',
        invite360Message: '',
        invite360SubjectLine: ''
      },
      demo: {
        source: [],
        selected: [],
        checked: [],
        include: [...Array(39).keys()]
      },
      newEmailRules: {
        email: [
          {
            required: true,
            type: 'email',
            message: 'Please input an email address',
            trigger: 'blur'
          }
        ]
      },
      rules: {
        emailSubject: [
          {
            required: true,
            message: 'Please input Email Subject',
            trigger: 'blur'
          },
          {
            min: 3,
            message: 'Length should be 3 characters at minimum',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  watch: {
    'settingsForm.receiveReport': {
      handler: function(after, before) {
        // Changes detected.
        if (after === false) {
          this.settingsForm.downloadReport = false;
        }
      },

      deep: true
    },

    'demo.checked': {
      handler: function(after, before) {
        this.anonymousNotice = 0;
        for (const inc in after) {
          if (after[inc]) {
            console.log('inc', parseInt(inc, 10));
            switch (parseInt(inc, 10)) {
              case 10:
              case 11:
              case 12:
                this.anonymousNotice += 1;
                break;
            }
          }
        }
      },
      deep: true
    }
  },
  created() {
    axios
      .get('settings/get')
      .then(r => {
        // console.log(r.data.rawSettings);
        this.settings = Object.assign({}, r.data.rawSettings);
        this.settingsForm.emailSubject = this.settings.email_subject_line;
        this.settingsForm.emailMessage = this.settings.email_message;

        this.settingsForm.receiveReport =
          this.settings.user_receive != 'Users to Not Receive' ? true : false;
        this.settingsForm.downloadReport =
          this.settings.user_download == 'Allow Download' ? true : false;

        // Handle emails
        if (this.settings.email_to.indexOf(',') > -1) {
          this.settingsForm.emails = this.settings.email_to.split(',');
        } else {
          if (this.settings.email_to !== undefined) {
            if (this.settings.email_to.trim().length > 0) {
              this.settingsForm.emails.push(this.settings.email_to);
            }
          }
        }
        // distributor enabled
        this.settingsForm.enablePackages =
          this.settings.enable_packages === 'Enabled' ? true : false;
        this.settingsForm.enableEmailWizard =
          this.settings.enable_email_wizard === 'Enabled' ? true : false;

        // Show photo upload form
        this.settingsForm.photoUploadForm =
          this.settings.enable_photo_upload === 'Enabled' ? true : false;

        // invite message
        this.settingsForm.inviteMessage = this.settings.invite_message;
        this.settingsForm.inviteSubjectLine = this.settings.invite_subject_line;

        // invite message
        this.settingsForm.invite360Message = this.settings.invite_360_message;
        this.settingsForm.invite360SubjectLine = this.settings.invite_360_subject_line;
      })
      .catch(e => {
        console.log(e);
      });
    axios
      .get('demo/get')
      .then(r => {
        // console.log(r);
        this.demo.source = Object.assign([], r.data.source);
        this.demo.selected = r.data.selected.demoData;

        this.demo.source.sort((a, b) => {
          return a.order - b.order;
        });

        for (const i in this.demo.source) {
          const id = this.demo.source[i].id;
          this.demo.checked[id] = false;
          if (this.demo.selected['demo_data_' + id] === 'enabled') {
            this.demo.checked[id] = true;
            if (id === 10 || id === 11 || id === 12) {
              this.anonymousNotice++;
            }
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
    axios
      .get('client/availableTests')
      .then(r => {
        // console.log(r);
        const lang = [];
        const inst = [];
        // Instruments
        const enabledTests = [];
        const checkedTests = [];
        for (const ii in r.data.enabledTests) {
          enabledTests.push(r.data.enabledTests[ii].test_id);
        }
        for (const ii in r.data.checkedTests) {
          if (r.data.checkedTests[ii].enabled === 1) {
            checkedTests.push(r.data.checkedTests[ii].test_id);
          }
        }
        // console.log('checked: ', checkedTests);

        for (const iii in r.data.tests) {
          if (enabledTests.indexOf(r.data.tests[iii].test_id) > -1) {
            inst.push({
              value: r.data.tests[iii].test_id,
              label: r.data.tests[iii].test_name_eng
            });
            const id = r.data.tests[iii].test_id;
            // this.form.instrumentNames[id] = r.data.tests[iii].test_name_eng;
          }
          if (checkedTests.indexOf(r.data.tests[iii].test_id) > -1) {
            // distributorInstrument[d.value]
            this.distributorInstrument[r.data.tests[iii].test_id] = true;
          }
        }
        // console.log(this.distributorInstrument);

        this.instrumentNames = inst;
      })
      .catch(e => {
        console.log(e);
      });
  },
  methods: {
    onSuccess() {},
    ...mapActions('auth', ['emulate']),
    showEmailDelete(email) {
      this.emailDeleteForm = true;
      this.removeEmail = email;
    },
    confirmAddEmail() {
      const e = this.newEmailForm.email;
      this.settingsForm.emails.push(e);
      this.emailAddForm = false;
    },
    confirmDeleteEmail(email) {
      const i = this.settingsForm.emails.indexOf(this.removeEmail);
      if (i > -1) {
        this.settingsForm.emails.splice(i, 1);
      }
      this.emailDeleteForm = false;
    },
    showEmailAdd() {
      this.emailAddForm = true;
    },
    saveSettings() {
      axios
        .post('settings/store', this.settingsForm)
        .then(r => {
          // console.log(r);
          this.$message({
            message: 'Saved Settings',
            type: 'success'
          });
        })
        .catch(e => {
          console.log(e);
          this.$message.error('Unable to save settings');
        });
    },
    saveDemographics() {
      axios
        .post('demo/store', this.demo.checked)
        .then(r => {
          this.$message({
            message: 'Saved Demographic Questions',
            type: 'success'
          });
        })
        .catch(e => {
          console.log(e);
          this.$message.error('Unable to save demographic questions');
        });
    },
    updateAuthentication() {
      axios
        .post('settings/password', this.auth)
        .then(r => {
          this.auth = {
            oldPassword: '',
            password1: '',
            password2: ''
          };
          this.$message({
            message: 'Updated Password',
            type: 'success'
          });
        })
        .catch(e => {
          console.log(e);
          this.$message.error('Unable to update your password');
        });
    }
  }
};
</script>